import React, { useState, useEffect } from "react";
import axios from 'axios';

import CertificationCanvas from './CertificationCanvas';

const CertificationDetail = ({varShowDetail,varDetailInfo,setDetailInfo,varLevelList,CloseCertificationDetail,GetCertificationList}) => {

  const [varSearchStatus, setSearchStatus] = useState(varDetailInfo.ce_status);
  const [varCertificationFile,setCertificationFile] = useState('');

  useEffect(() => {
    if(varShowDetail) setSearchStatus(varDetailInfo.ce_status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varShowDetail]);

  //발급상태 선택값 저장
  const onSearchStatusHandler = (e) => {  
    if(varDetailInfo.ce_status===1) {
      alert('수료증을 먼저 생성하고 저장하면 자동으로 발급완료로 변경됩니다.');
      return false;
    } 
    setSearchStatus(Number(e.currentTarget.value));
  }

  //발급상태 변경
  const onUpdateStatusHandler = async(e) => {
    const sendData = {ce_idx:varDetailInfo.ce_idx,ce_status:varSearchStatus,fileName:varCertificationFile};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_certification_status`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        GetCertificationList();
        CloseCertificationDetail();
      } else {
        alert(datas.message);
      }
    });
  }

  //팝업창 - 수료증 생성/보기
  const [varShowCanvas, setShowCanvas] = useState(false);
  const ToggleCertificationCanvas = (bmode) => {
    setShowCanvas(bmode);
  }

  return (
    <div className={varShowDetail?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"400px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>수료증 발급 현황</div>
          <div className="layer__pop__close" onClick={()=>CloseCertificationDetail()}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px",display:"flex",justifyContent:"space-around"}}> 
          <div className="main-box">
            <table className="write-s">
              <colgroup><col width="30%"></col><col width="70%"></col></colgroup>
              <thead></thead>
              <tbody>
                <tr><th>센터명</th><td>{varDetailInfo.bh_company}</td></tr>
                <tr><th>원생명</th><td>{varDetailInfo.ch_name}</td></tr>
                <tr><th>개월</th><td>{varDetailInfo.ch_month}</td></tr>
                <tr><th>생년월일</th><td>{varDetailInfo.ch_birthday}</td></tr>
                <tr><th>출석회차</th><td>{varDetailInfo.ch_attendance}</td></tr>
                <tr><th>레벨</th><td>{varDetailInfo.vl_name}</td></tr>
                <tr><th>발급현황</th><td>{varDetailInfo.ce_state}</td></tr>
                <tr><th>종류</th><td>{varDetailInfo.ce_lang_string}</td></tr>
                <tr><th>영문명(원생)</th><td>{varDetailInfo.ch_ename}</td></tr>
                <tr><th>영문명(센터)</th><td>{varDetailInfo.bh_ecompany}</td></tr>
                <tr><th>발급희망일</th><td>{varDetailInfo.ce_idate}</td></tr>
                <tr><th>등록일</th><td>{varDetailInfo.ce_rdate}</td></tr>
                <tr>
                  <th>발급현황</th>
                  <td>
                    <select value={varSearchStatus} style={{width:"120px"}} onChange={(e)=>onSearchStatusHandler(e)}>
                      <option value={0}>발급선택</option>
                      <option value={1}>발급대기</option>
                      <option value={2}>발급완료</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="btn-center">
          <button onClick={()=>ToggleCertificationCanvas(true)} style={{width:"130px"}} className="btn">
            {varDetailInfo.ce_status===1?"수료증 생성":"수료증 보기"}
          </button>
          <button onClick={e=>onUpdateStatusHandler(e)} style={{width:"90px"}} className="btn">저장</button>
          <button onClick={()=>CloseCertificationDetail()} style={{width:"90px"}} className="btn line">닫기</button>
        </div>
      </div>
      <CertificationCanvas varShowCanvas={varShowCanvas} varDetailInfo={varDetailInfo} setDetailInfo={setDetailInfo}
          varLevelList={varLevelList} varSearchStatus={varSearchStatus} setSearchStatus={setSearchStatus}
          ToggleCertificationCanvas={ToggleCertificationCanvas} setCertificationFile={setCertificationFile}/>
    </div> 
  )
}
export default CertificationDetail;